import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styles from "./styles.module.scss";
import cx from "classnames";
/*
 * Underlined Button Component
 */
const RoundedGainfulButton = ({ label, onClick, extraClassName, disabled, outlined, whiteButton, type = "button", dataAttr, color, }) => (_jsx("button", { onClick: onClick, type: type || "button", className: cx(styles.rouned_gainful_button, styles[color], extraClassName, {
        [styles.white_button]: whiteButton,
        [styles.disabled]: disabled,
        [styles.outlined]: outlined,
    }), "data-profileclick": label, disabled: disabled, "data-attr": dataAttr || "rounded-gainful-button", children: label }));
export default RoundedGainfulButton;
